module.exports = __webpack_public_path__ + "static/media/logo_vuejs.3837cf4c.png";